import { useNavigate, useParams } from "react-router-dom";
import { CreditNotePage as CreditNotePageView } from "@/components/CreditNotePage";
import { useModules } from "@/auth/ModulesContext";
import { useEInvoicingRegistered } from "@/hooks/useEInvoicingRegistered";

export function CreditNotePage() {
  const navigate = useNavigate();
  const { creditNoteId } = useParams<{ creditNoteId: string }>();
  const { hasModule, modules } = useModules();
  // Gated on a resolved entitlement, as on the invoice page, so a non-entitled client is never read.
  const eInvoicingEnabled = modules !== null && hasModule("ar.e_invoicing");
  const eInvoicingRegistered = useEInvoicingRegistered(eInvoicingEnabled);

  if (!creditNoteId) return null;

  return (
    <CreditNotePageView
      creditNoteId={creditNoteId}
      eInvoicingEnabled={eInvoicingEnabled}
      eInvoicingRegistered={eInvoicingRegistered}
      onBack={() => navigate("/credit-notes")}
      onInvoiceClick={(id) => navigate(`/invoices/${id}`)}
      onCustomerClick={(id) => navigate(`/customers/${id}`)}
    />
  );
}
